import { useQuery } from '@apollo/client';

import { IndustryByIdDocument } from '../../graphql/queries/industry-by-id.gql-types';
import { useAllIndustries } from '../use-companies-industries/use-companies-industries';

interface UseIndustryIdProps {
  industrySEOName: string;
  segmentSEOName?: string;
}

const extractIdFromScrambledId = (scrambledId?: string): string | undefined => {
  return scrambledId?.split('.')[0];
};

const NOT_FOUND_ID = '-1';

export const useIndustryId = ({
  industrySEOName,
  segmentSEOName,
}: UseIndustryIdProps) => {
  const { orderedIndustries, loading: isAllIndustriesLoading } =
    useAllIndustries();

  // Find the industry by SEO name
  const industryResult = orderedIndustries.find(
    (el) => el?.industry?.seoName === industrySEOName
  );
  const scrambleIndustryId = industryResult?.industry?.id ?? NOT_FOUND_ID;
  const industryId =
    extractIdFromScrambledId(scrambleIndustryId) ?? NOT_FOUND_ID;

  // Query industry details
  const { data: responseData, loading: isIndustryLoading } = useQuery(
    IndustryByIdDocument,
    {
      variables: { id: scrambleIndustryId },
    }
  );

  const isLoading = isAllIndustriesLoading || isIndustryLoading;

  // Find the segment by SEO name
  const segments = responseData?.industryById?.segments;
  const segmentResult = segments?.find(
    (segment) => segment.seoName === segmentSEOName
  );
  const scrambleSegmentId = segmentResult?.id ?? NOT_FOUND_ID;
  const segmentId = extractIdFromScrambledId(scrambleSegmentId) ?? NOT_FOUND_ID;

  return {
    isLoading,
    scrambleIndustryId,
    industryId,
    scrambleSegmentId,
    segmentId,
  };
};
